import { render } from "./prime-tabpanel.vue?vue&type=template&id=6160b040"
import script from "./prime-tabpanel.vue?vue&type=script&lang=js"
export * from "./prime-tabpanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__